export default "__VITE_ASSET__0e48a640__"